import React from 'react';
import { motion } from 'framer-motion';
import { Star, TrendingUp } from 'lucide-react';
type Testimonial = {
  name: string;
  avatar: string | null;
  content: string;
  points: number;
  scoreImage: string | null;
};
const testimonials: Testimonial[] = [{
  name: 'Yaude Bermudez',
  avatar: 'https://cdn.magicpatterns.com/uploads/2LB9Mo6WFwYTJCdMnMUxNK/Captura_de_pantalla_2026-06-01_a_la(s)_6.17.20_p.m..png',
  content: 'Eduardo y su equipo me ayudaron a aumentar mi puntaje de credito y conseguir mas de 30,000 dolares en un prestamo personal. Agradecido con su ayuda y su trabajo. Muy profesional.',
  points: 120,
  scoreImage: 'https://cdn.magicpatterns.com/uploads/sq5qoudUUFbSYsoozNuuGN/Captura_de_pantalla_2026-06-01_a_la(s)_5.55.23_p.m..png'
}, {
  name: 'Carlos Sthormes',
  avatar: 'https://cdn.magicpatterns.com/uploads/9Cg3DFewrtjXoxtBbkUjJE/IMG_0817.jpg',
  content: 'Trabajar con el Eduardo y su equipo es excelente, hicieron exactamente lo que dijeron que harian y de verdad estoy muy contento con los resultados, mi credito subio un monton y logre tener hasta 35.000 dolares en mi primera tarjeta de credito de negocios, son increibles.',
  points: 149,
  scoreImage: 'https://cdn.magicpatterns.com/uploads/edVxDFjn85dFbVdcbhau9p/Captura_de_pantalla_2026-06-01_a_la(s)_6.00.47_p.m..png'
}, {
  name: 'Dario Hagopian',
  avatar: 'https://cdn.magicpatterns.com/uploads/qeHBAZR9tDZnpD3wXGF76m/IMG_0816.jpg',
  content: 'Eduardo es un profesional en lo que hace, la atencion es increible, los tiempos de respuesta son muy buenos y mi puntaje crecio una barbaridad. Pude comprar mi casa gracias a eso, altamente recomendado.',
  points: 110,
  scoreImage: 'https://cdn.magicpatterns.com/uploads/x14rxc2BSiUHpK5VZFyV7Y/Captura_de_pantalla_2026-06-01_a_la(s)_5.58.22_p.m..png'
}];
function CreditScoreMock({
  points
}: {
  points: number;
}) {
  return <div className="relative w-full aspect-[16/10] rounded-xl overflow-hidden bg-zinc-800/80 border border-white/5" data-id="element-263">
      {/* Blurred dashboard background mock */}
      <div className="absolute inset-0 p-3 opacity-50" data-id="element-264">
        <div className="flex gap-2 mb-2" data-id="element-265">
          <div className="h-6 w-6 rounded bg-blue-600/40" data-id="element-266" />
          <div className="flex-1 h-6 rounded bg-zinc-700/60" data-id="element-267" />
          <div className="h-6 w-12 rounded bg-zinc-700/60" data-id="element-268" />
        </div>
        <div className="space-y-1.5" data-id="element-269">
          <div className="h-3 w-3/4 rounded bg-zinc-700/40" data-id="element-270" />
          <div className="h-3 w-1/2 rounded bg-zinc-700/40" data-id="element-271" />
          <div className="h-3 w-2/3 rounded bg-zinc-700/40" data-id="element-272" />
        </div>
      </div>

      {/* Popup card */}
      <div className="absolute inset-x-3 bottom-3 top-6 bg-white rounded-lg shadow-2xl p-3 flex gap-3 items-center" data-id="element-273">
        <div className="shrink-0 h-full aspect-square bg-blue-600 rounded flex flex-col items-center justify-center text-white" data-id="element-274">
          <div className="text-xl md:text-2xl font-bold leading-none" data-id="element-275">
            +{points}
          </div>
          <div className="text-[8px] md:text-[9px] mt-1 opacity-90" data-id="element-276">points</div>
        </div>
        <div className="flex-1 min-w-0" data-id="element-277">
          <div className="text-[10px] md:text-xs font-bold text-zinc-900 leading-tight mb-1" data-id="element-278">
            Congratulations! Your Credit Score Increased.
          </div>
          <div className="text-[8px] md:text-[9px] text-zinc-500 leading-tight mb-2" data-id="element-279">
            Your credit score has gone up{' '}
            <span className="font-semibold text-zinc-700" data-id="element-280">{points} points</span>
            .
          </div>
          <div className="inline-flex items-center px-2 py-1 rounded-full bg-blue-500 text-white text-[8px] md:text-[9px] font-medium" data-id="element-281">
            View your Smart Credit Report®
          </div>
        </div>
        <div className="absolute top-1.5 right-1.5 text-zinc-400 text-[10px]" data-id="element-282">
          ×
        </div>
      </div>
    </div>;
}
export function Testimonials() {
  return <section id="resultados" className="py-32 bg-black px-4 sm:px-6 lg:px-8 border-t border-white/5 relative overflow-hidden" data-id="element-283">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_bottom,rgba(245,158,11,0.06),transparent_50%)] pointer-events-none" data-id="element-284" />

      <div className="max-w-7xl mx-auto relative z-10" data-id="element-285">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        duration: 1,
        ease: [0.16, 1, 0.3, 1]
      }} className="text-center mb-20" data-id="element-286">
          <span className="inline-block text-xs font-semibold tracking-[0.3em] uppercase bg-gradient-to-b from-amber-300 to-amber-500 bg-clip-text text-transparent mb-6" data-id="element-287">
            Casos Reales
          </span>
          <h2 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white tracking-tight mb-6 leading-[1.1]" data-id="element-288">
            Ellos Dijeron{' '}
            <span className="italic font-black bg-gradient-to-b from-amber-200 via-amber-400 to-amber-600 bg-clip-text text-transparent" data-id="element-289">
              Si.
            </span>{' '}
            Mira Lo Que Paso.
          </h2>
          <p className="text-lg md:text-xl text-white/50 font-light max-w-2xl mx-auto" data-id="element-290">
            Esto es lo que sucede cuando dejas de adivinar y sigues un sistema
            probado.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-291">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.8,
          delay: index * 0.15,
          ease: [0.16, 1, 0.3, 1]
        }} className="flex flex-col p-7 rounded-3xl bg-zinc-950 border border-white/[0.08] hover:border-amber-500/20 transition-all duration-500" data-id="element-292">
              {/* Header: avatar + name + stars */}
              <div className="flex items-center gap-4 mb-6" data-id="element-293">
                <div className="h-14 w-14 rounded-full bg-gradient-to-br from-zinc-700 to-zinc-900 border border-white/10 flex items-center justify-center text-white font-semibold text-lg shrink-0 overflow-hidden" data-id="element-294">
                  {testimonial.avatar ? <img src={testimonial.avatar} alt={testimonial.name} className="h-full w-full object-cover" data-id="element-295" /> : testimonial.name.split(' ').map(n => n[0]).slice(0, 2).join('')}
                </div>
                <div data-id="element-296">
                  <div className="text-white font-semibold text-lg leading-tight mb-1" data-id="element-297">
                    {testimonial.name}
                  </div>
                  <div className="flex gap-0.5" data-id="element-298">
                    {[...Array(5)].map((_, i) => <Star key={i} className="h-3.5 w-3.5 fill-amber-400 text-amber-400" data-id="element-299" />)}
                  </div>
                </div>
              </div>

              {/* Quote */}
              <p className="italic text-white/60 font-light leading-relaxed text-[15px] mb-7 flex-grow" data-id="element-300">
                "{testimonial.content}"
              </p>

              {/* Points pill */}
              <div className="mb-5" data-id="element-301">
                <div className="inline-flex items-center gap-2 px-4 py-2.5 rounded-xl bg-gradient-to-r from-amber-500/10 to-amber-500/5 border border-amber-500/20 w-full" data-id="element-302">
                  <TrendingUp className="h-4 w-4 text-amber-400" strokeWidth={2.5} data-id="element-303" />
                  <span className="font-bold bg-gradient-to-b from-amber-300 to-amber-500 bg-clip-text text-transparent" data-id="element-304">
                    +{testimonial.points} pts
                  </span>
                </div>
              </div>

              {/* Credit score proof: real screenshot if provided, else CSS mock */}
              {testimonial.scoreImage ? <div className="relative w-full rounded-xl overflow-hidden border border-white/5" data-id="element-305">
                  <img src={testimonial.scoreImage} alt={`Aumento de puntaje de crédito de ${testimonial.name}: +${testimonial.points} puntos`} className="w-full h-auto" data-id="element-306" />
                </div> : <CreditScoreMock points={testimonial.points} data-id="element-307" />}
            </motion.div>)}
        </div>
      </div>
    </section>;
}